import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';
import dateFns from 'date-fns';
import { inFrame } from './lib/auth';
import ApparatusFuelContainer from './ApparatusFuel/ApparatusFuelContainer';
import FuelUploadSuccess from './ApparatusFuel/FuelUploadSuccess';
import ApparatusFuelConfirmation from './ApparatusFuelConfirmation/ApparatusFuelConfirmation';
import AppHeader from './AppHeader';
import { AuthProvider, PrivateRoute, Loader, Login, Logout, Flex, VersionNum } from './components';
import { fuelerDB, theme } from './lib';
import './App.css';

const Root = styled(Flex)`
    flex-direction: column;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: space-between;
`;

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            online: navigator.onLine,
            user: {},
            account: {},
            loggingApparatus: {},
            date: dateFns.format(new Date(), 'MM/DD/YYYY'),
            syncNumber: 0,
            form: {
                fuelVolume: '',
                DEFVolume: '',
                odometer: '',
                apparatusHours: '',
                notes: '',
                cost: ''
            }
        };

        this.toggleStatus = this.toggleStatus.bind(this);
        this.onConfirmFuel = this.onConfirmFuel.bind(this);
        this.logFuel = this.logFuel.bind(this);
        this.syncApp = this.syncApp.bind(this);
        this.cacheLog = this.cacheLog.bind(this);
        this.router = undefined;
    }

    cacheLog(maintenanceLog) {
        fuelerDB.logs.put(maintenanceLog).then(() => {
            this.setState({
                syncNumber: this.state.syncNumber + 1
            });

            this.props.history.push('/success');
        });
    }

    componentWillReceiveProps() {
        this.fetchUserData();
    }

    componentDidMount() {
        if (inFrame()) return;

        if (this.props.account) {
            fuelerDB.logs.toArray(logs => {
                this.setState(
                    {
                        syncNumber: logs.length
                    },
                    () => {
                        this.syncApp();
                    }
                );
            });

            window.addEventListener('online', this.toggleStatus);
            window.addEventListener('offline', this.toggleStatus);
        }
    }

    fetchUserData() {
        fuelerDB.user.get(1).then(user => {
            if (user) {
                this.setState({ user });
            }
        });

        if (this.state.online && this.props.api) {
            Promise.all([this.props.api.get('/accounts/me'), this.props.api.get('/users/me')])
                .then(values => {
                    fuelerDB.user.put(Object.assign({}, values[1].data.user, { id: 1 }));

                    this.setState({
                        account: values[0].data.account,
                        user: values[1].data.user
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }

    toggleStatus() {
        this.setState({ online: navigator.onLine });
        this.syncApp();
    }

    syncApp() {
        if (navigator.onLine) {
            fuelerDB.logs.toCollection().eachPrimaryKey(key => {
                fuelerDB.logs.get(key).then(maintenanceLog => {
                    this.props.api
                        .post(`/apparatuses/${maintenanceLog.departmentApparatusID}/maintenance`, maintenanceLog)
                        .then(res => {
                            fuelerDB.logs.delete(key);
                            this.setState({
                                syncNumber: this.state.syncNumber - 1
                            });
                        })
                        .catch(err => {
                            // TODO: error toast.
                            console.error(err);
                            if (err.response.status === 404) {
                                // TODO: toast notification for failed sync due to bad request data.
                                fuelerDB.logs.delete(key);
                                this.setState({
                                    syncNumber: this.state.syncNumber - 1
                                });
                            }
                        });
                });
            });
        }
    }

    logFuel(loggingApparatus, form) {
        var reducedForm = {};
        Object.keys(form).forEach(key => {
            reducedForm[key] = form[key].value;
        });

        this.setState({
            form: reducedForm,
            loggingApparatus: loggingApparatus,
            date: dateFns.format(new Date(), 'MM/DD/YYYY')
        });
    }

    onConfirmFuel() {
        this.setState({
            form: {
                fuelVolume: '',
                DEFVolume: '',
                odometer: '',
                apparatusHours: '',
                notes: ''
            }
        });
    }

    render() {
        if (inFrame()) return null;

        return (
            <ThemeProvider theme={theme}>
                <Root id="router-root">
                    <AppHeader
                        loggedIn={!!this.props.account}
                        logout={this.signOut}
                        online={this.state.online}
                        user={this.state.user}
                        syncNumber={this.state.syncNumber}
                    />
                    <Route path="/login" render={() => <Login signIn={this.props.signIn} />} />
                    {this.props.account && this.props.api ? (
                        <Wrapper>
                            <PrivateRoute
                                path="/"
                                exact
                                formData={this.state.form}
                                loggingApparatus={this.state.loggingApparatus}
                                online={this.state.online}
                                component={ApparatusFuelContainer}
                                onSubmitForm={this.logFuel}
                                api={this.props.api}
                            />
                            <PrivateRoute
                                exact
                                path="/success"
                                online={this.state.online}
                                component={FuelUploadSuccess}
                            />
                            <PrivateRoute
                                path="/confirm"
                                user={this.state.user}
                                online={this.state.online}
                                cacheLog={this.cacheLog}
                                onConfirm={this.onConfirmFuel}
                                component={ApparatusFuelConfirmation}
                                form={this.state.form}
                                loggingApparatus={this.state.loggingApparatus}
                                date={this.state.date}
                                api={this.props.api}
                            />
                            <Route path="/logout" render={() => <Logout signOut={this.props.signOut} />} />
                            <VersionNum />
                        </Wrapper>
                    ) : (
                        <Route path="/" exact component={() => (
                            <Wrapper>
                                <Loader />
                                <VersionNum />
                            </Wrapper>
                        )} />
                    )}
                </Root>
            </ThemeProvider>
        );
    }
}

export default AuthProvider(App);



// WEBPACK FOOTER //
// ./src/App.js